import "./styles.scss";

import { useCardNav, useIsMobile } from "hooks/app";
import React, { useState } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

export default function CategoriesList() {
  const [toggled, setToggled] = useState([]);
  const isMobile = useIsMobile(["XXXS", "XXS", "XS", "SM", "MD"]);
  const { navItems } = useCardNav();

  const limit = 16;

  const toggleMore = (i, toggle) => {
    if (toggle) {
      setToggled([...toggled, i]);
    } else {
      setToggled(toggled.filter((t) => t !== i));
    }
  };

  return (
    <section className="card-categories-list-wrapper">
      <h2 className="card-categories-list-title">Browse All Cards</h2>
      <ul className="card-categories-list">
        {navItems?.map((top, i) => (
          <li
            className={`top-category ${toggled.includes(i) ? "toggled" : ""} ${i === navItems.length - 1 ? "order-first" : ""}`}
            key={`card-category-${i + 1}`}
            onClick={() => isMobile && toggleMore(i, !toggled.includes(i))}
          >
            <h3 className="card-category-name">
              <span>{top.shortCategoryName}</span>
              {isMobile && (
                <span className="toggle-icon" onClick={() => toggleMore(i, !toggled.includes(i))}>
                  {!toggled.includes(i) ? <IoChevronDown /> : <IoChevronUp />}
                </span>
              )}
            </h3>
            <ul className="mid-category">
              {top.children?.map((c, j) => (
                <li
                  key={`card-mid-category-${i}-${j + 1}`}
                  className={`card-mid-category-item ${(j >= limit || isMobile) && !toggled.includes(i) ? "hidden" : ""}`}
                >
                  <a href={c.fullCardCategorySlug} className="card-midcategory-name">
                    {c.shortCategoryName}
                  </a>
                </li>
              ))}
              {!isMobile && top.children?.length - 1 > limit && !toggled.includes(i) && (
                <li className="card-mid-category-item" onClick={() => toggleMore(i, true)}>
                  <span className="card-midcategory-name link">+ {top.children?.length - limit - 1} more</span>
                </li>
              )}
            </ul>
          </li>
        ))}
      </ul>
    </section>
  );
}
